import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { MainDiagnosisService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MainDiagnosisCreateDto,
  MainDiagnosisDto,
  MainDiagnosisExcelDownloadDto,
  MainDiagnosisUpdateDto,
} from '../proxy/planning/dtos/main-diagnosis';
import { MAINDIAGNOSIS_CONFIG, MAINDIAGNOSIS_FIELDS } from './main-diagnosis.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-main-diagnosis',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MainDiagnosisService, ConfirmationService],
  templateUrl: './main-diagnosis.html',
  styleUrl: './main-diagnosis.scss',
})
export class MainDiagnosis extends BaseCrudComponent<
  MainDiagnosisDto,
  MainDiagnosisCreateDto,
  MainDiagnosisUpdateDto,
  MainDiagnosisExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(MainDiagnosisService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('MainDiagnosis', ids),
  };
  config = MAINDIAGNOSIS_CONFIG;
  fields = MAINDIAGNOSIS_FIELDS;

  protected prepareUpdateDto(data: any, selected: MainDiagnosisDto): MainDiagnosisUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MainDiagnosis';
  }
}
